module.exports = __webpack_public_path__ + "img/game3.1fefaa14.png";